"use client";

const Error = ({ reset }: { reset: () => void }) => {
  return (
    <div className="flex relative min-h-screen">
      <div className="flex flex-col md:mx-12 lg:mx-10 xl:mx-14 lg:mt-8 space-y-6 mt-4 w-full px-3">
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <div className="w-16 h-16 mb-4 rounded-full bg-red-100 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Failed to load category
          </h3>
          <p className="text-gray-600 mb-4">
            We couldn&apos;t load the product category. Please try again.
          </p>
          <button
            onClick={() => reset()}
            className="px-4 py-2 bg-[#037a6a] text-white rounded-lg hover:bg-[#025e53] transition-colors"
          >
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default Error;
